import { Component, OnInit } from '@angular/core';
import { FileUploader, FileUploaderOptions } from "ng2-file-upload"; //FileSelectDirective,
import { HttpEvent, HttpEventType } from "@angular/common/http";
import { FormBuilder, Validators} from '@angular/forms'; //FormGroup, FormControl,
import { Router } from '@angular/router'; //, NavigationExtras

// PROVIDER
import {BasicProvider} from '../providers/basic/basic';
import {UserProvider} from '../providers/user/user';

@Component({
  selector: 'app-my-account',
  templateUrl: './my-account.component.html',
  styleUrls: ['./my-account.component.css']
})
export class MyAccountComponent implements OnInit {

  profileForm;
  profileForm_error;
  cp;
  cp_error;
  ce;
  ce_error;

  validation_message = {
    'full_name': {
      'required': 'Please provide name.'
    },
    'email': {
      'required': 'Please provide email.'
    },
    'phone': {
      'required': 'Please provide phone number.',
      'pattern': 'Please enter valid phone.',
      'minlength': 'phone number length must be between 8 to 10.',
      'maxlength': 'phone number length must be between 8 to 10.'
    }
  };

  options;
  uploader: FileUploader;
  url = '';
  allowedMimeType = [];
  file;
  uploadInProgress = false;
  uploadProgress = 0;
  hasValue = false;
  fileUploadType;
  imgPreview;
  
  constructor(
    public builder:FormBuilder,
    public bp:BasicProvider, 
    public up:UserProvider,
    public router: Router,
  ) { 
    this.signupValidate();
    this.changePassValidate();
    this.changeEmailValidate();
    this.allowedMimeType = [
      "image/png",
      "image/gif",
      "image/jpg",
      "image/jpeg",
    ];
    this.url = this.bp.httpUrl + "users/update_user_signature_files";
    this.uploader = new FileUploader({
      url: this.url,
      headers: this.options,
      itemAlias: "image",
      allowedMimeType: this.allowedMimeType,
    });

    var uo: FileUploaderOptions = {};
    uo.headers = [{ name: "sid", value: this.up.sid }];
    this.uploader.setOptions(uo);
  }

  ngOnInit() {
    this.uploader.onAfterAddingFile = (file) => {
      //let file_string = file.target.file[0];
      file.withCredentials = false;
      this.uploader.uploadAll();   
    };
    
    this.uploader.onCompleteItem = (item: any, success: any, status: any, headers: any) => {
      let result = JSON.parse(success);
      this.up.signature = result.data.image_name;
      this.up.updateProfileSign(this.up.signature);
      this.bp.show_toast('Success',result.message);
    };

    this.uploader.onWhenAddingFileFailed = (item, filter, options) => {
      this.bp.show_toast('Error','Only jpeg, png, gif images are allowed.');
    };
  }

  //Show / hide password
  current_pass_type = false;
  new_pass_type = false;
  confirm_pass_type = false;
  showPassword(type){
    if( type == 'current_pass_type' ){
      if(this.current_pass_type)
        this.current_pass_type = false;
      else
        this.current_pass_type = true;
    } else if ( type == 'new_pass_type' ) {
      if(this.new_pass_type)
        this.new_pass_type = false;
      else
        this.new_pass_type = true;
    } else if ( type == 'confirm_pass_type' ) {
      if(this.confirm_pass_type)
        this.confirm_pass_type = false;
      else
        this.confirm_pass_type = true;
    }
  }

  signupValidate() {
    this.profileForm = this.builder.group({
      full_name: [this.up.full_name, Validators.compose([this.bp.required])], 
      email: [this.up.email, Validators.compose([this.bp.required])], 
      phone: [this.up.phone, Validators.compose([this.bp.required, Validators.pattern(/^[0-9]+/), Validators.minLength(8), Validators.maxLength(10)])]
    });
  }

  changePassValidate() {
    this.cp_error = '';
    this.cp = this.builder.group({
      old_password: ['', Validators.compose([this.bp.required, Validators.minLength(6), Validators.maxLength(20)])], 
      new_password: ['', Validators.compose([this.bp.required, Validators.minLength(6), Validators.maxLength(20)])], 
      confirm_password: ['', Validators.compose([this.bp.required, Validators.minLength(6), Validators.maxLength(20)])], 
      
    });
  }

  changeEmailValidate() {
    this.ce_error = '';
    this.ce = this.builder.group({
      old_email: [this.up.email, Validators.compose([this.bp.required, Validators.pattern('([a-zA-Z0-9_.]{1}[a-zA-Z0-9_.]*)((@[a-zA-Z]{2}[a-zA-Z]*)[\\\.]([a-zA-Z]{2}|[a-zA-Z]{3}))([\\\.]([a-zA-Z]{2}|[a-zA-Z]{3}))?')])],
      new_email: ['', Validators.compose([this.bp.required, Validators.pattern('([a-zA-Z0-9_.]{1}[a-zA-Z0-9_.]*)((@[a-zA-Z]{2}[a-zA-Z]*)[\\\.]([a-zA-Z]{2}|[a-zA-Z]{3}))([\\\.]([a-zA-Z]{2}|[a-zA-Z]{3}))?')])],
      confirm_email: ['', Validators.compose([this.bp.required, Validators.pattern('([a-zA-Z0-9_.]{1}[a-zA-Z0-9_.]*)((@[a-zA-Z]{2}[a-zA-Z]*)[\\\.]([a-zA-Z]{2}|[a-zA-Z]{3}))([\\\.]([a-zA-Z]{2}|[a-zA-Z]{3}))?')])]
    });
  }

  async profileSubmit() {
    //console.log(this.profileForm);
    if (this.bp.validation(this.profileForm, this.validation_message)) {
      let submitData = this.profileForm.value;

      //console.log(submitData);
      this.up.getDataPromise().subscribe( value => {
        console.log('value',value);
        var x = Object.assign({}, value, submitData);
        console.log('x',x);
        this.up.setData(x);
        this.bp.hitApi('users/edit_profile', 'POST', submitData, true, true)
          .subscribe(
            success => {
              this.profileForm_error = '';
              if (success.type == true) {
                this.bp.show_toast('Success',success.message);
              } else {
                this.bp.show_toast('Error',success.message);
              }
            }, 
            error => {}
          );
      });
    } else {
      this.profileForm_error = this.bp.validation_error;
    }
  }

  async changePassSubmit() {
    var validation_message = {
      'old_password': {
        'required': 'Old password is required field.',
        'minlength': 'Password length must be between 6 to 20.',
        'maxlength': 'Password length must be between 6 to 20.'
      },
      'new_password': {
        'required': 'Password is required field.',
        'minlength': 'Password length must be between 6 to 20.',
        'maxlength': 'Password length must be between 6 to 20.'
      }, 
      'confirm_password': {
        'required': 'Confirm password must be equal to password.',
        'minlength': 'Password length must be between 6 to 20.',
        'maxlength': 'Password length must be between 6 to 20.'
      }
    };

    if (this.bp.validation(this.cp, validation_message)) {

      if (this.cp.value.new_password != this.cp.value.confirm_password) {
        this.bp.show_toast('Error',validation_message['confirm_password']['required']);
        return false;
      }

      let submitData = this.cp.value;

      var data = Object.assign({}, submitData, { });
      this.bp.hitApi('users/change_password', 'POST', data, true, true)
        .subscribe(
          success => {
            if (success.type == true) {
              this.changePassValidate();
              this.bp.show_toast('Success',success.message);
            } else {
              this.bp.show_toast('Error',success.message);
            }
          }, 
          error => {

          }
        );

    } else {
      this.cp_error = this.bp.validation_error;
    }
  }


  async changeEmailSubmit() {
    var validation_message = {
      'old_email': {
        'required': 'Old Email is required field.',
        'pattern': 'Please enter valid email.'
      }, 
      'new_email': {
        'required': 'New Email is required field.',
        'pattern': 'Please enter valid email.'
      }, 
      'confirm_email': {
        'required': 'Confirm Email is required field.',
        'match': 'Confirm Email must be equal to New Email.',
        'pattern': 'Please enter valid email.'
      } 
      
    };

    if (this.bp.validation(this.ce, validation_message)) {
      if (this.ce.value.new_email != this.ce.value.confirm_email) {
        this.bp.showAlert(validation_message['confirm_email']['match']);
        return false;
      }

      let submitData = this.ce.value;

      var data = Object.assign({}, submitData, { });
      this.bp.hitApi('users/change_email', 'POST', data, true, true)
        .subscribe(
          success => {
            this.ce_error = '';
            if (success.type == true) {
              this.up.logout();
              this.bp.show_toast('Success',success.message);
            } 
            else {
              this.bp.show_toast('Error',success.message);
            }
          }, 
          error => {

          }
        );
    } else {
      this.ce_error = this.bp.validation_error;
    }
  }

  onchangeFile(event) {
    let allowFileType = ["jpg", "png", "jpeg"];
    let selectedFileType = event.target.files.length
      ? event.target.files[0].name.split(".").pop().toLowerCase()
      : "";
    if (!selectedFileType) return;
    console.log("selectedFileType==>", selectedFileType);
    if (!allowFileType.includes(selectedFileType)) {
      this.bp.show_toast(
        "Error",
        "Please select correct file of allow format. Allowled format are jpg, png, jpeg"
      );
      return;
    }

    //let data = { location: "users", type: "IMAGE" };
    let data = { location: "signatures", type:selectedFileType };
    let api = `warehouse/upload_files_sign`;
    const [file] = event.target.files;
    this.file = file;
    this.bp.hitApi(api, "GET", data, true, true).subscribe((success) => {
      this.hasValue = true;
      if (success.type == true) {
        this.bp.upload(success.data[0].url, file, null, true)
          .subscribe((event: HttpEvent<any>) => {
            switch (event.type) {
              case HttpEventType.Sent:
                this.uploadInProgress = true;
                break;
              case HttpEventType.UploadProgress:
                this.uploadProgress = Math.round(
                  (100 * event.loaded) / event.total
                );
                break;
              case HttpEventType.Response:
                this.resetUploadProgress();
                this.file = undefined;
                this.hasValue = true;
                let signature = success.data[0].location;
                this.imgPreview = success.data[0].preview;

                api = `users/update_user_signature_files`;
                this.bp
                  .hitApi(api, "POST", { signature }, true, true)
                  .subscribe((success) => {
                    if (success.type == true) {
                      this.up.signature = signature;
                      this.up.updateProfileSign(this.up.signature);
                      this.bp.show_toast("Success", success.message);
                    }
                  });
            }
          });
      } else {
        this.bp.show_toast("Error", success.message);
      }
    });
  }

  private resetUploadProgress() {
    this.uploadInProgress = false;
    this.uploadProgress = 0;
  }

  

}



// WEBPACK FOOTER //
// ./src/app/my-account/my-account.component.ts